import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@/lib/queryClient";
import App from "@/App";
import { SharePage } from "@/routes/SharePage";
import { LoginRoute } from "@/routes/LoginRoute";
import { VerifyRoute } from "@/routes/VerifyRoute";
import { LandingPage } from "@/components/pages/LandingPage";
import { SignupRoute } from "@/routes/SignupRoute";
import "./index.css";

const landingEnabled = !import.meta.env.VITE_WHITE_LABEL;

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <Routes>
          <Route path="/" element={landingEnabled ? <LandingPage /> : <Navigate to="/login" replace />} />
          <Route path="/signup" element={landingEnabled ? <SignupRoute /> : <Navigate to="/login" replace />} />
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/verify" element={<VerifyRoute />} />
          <Route path="/share/pdf" element={<SharePage />} />
          <Route path="/*" element={<App />} />
        </Routes>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);
